import { CheckIcon, List, UpgradeDialog } from '@buffer-mono/popcorn'

import * as React from 'react'
import ReactPlayer from 'react-player'
import trackCTAPaywallVideoPlayed from '../../../../tracking/trackPaywallVideoPlayed'
import { useUser } from '../../../../common/context/User'
import { MODALS } from '../../../../common/types'
import { PaywallCtas } from '../shared/PaywallCtas'

import type { JSX } from 'react'

const ANALYZE_HEADING =
  'One dashboard for your social media analytics and reporting'

const ANALYZE_DESCRIPTION =
  'Access in-depth insights on how to grow your following, reach more people, and boost your engagement.'

const ANALYZE_BULLET_POINTS = [
  'Get recommendations to grow your presence',
  'Measure social media performance',
  'Create gorgeous reports',
]

const AnalyzeUpgradePathModalContent = ({
  dismissModal,
}: {
  dismissModal: () => void
}): JSX.Element => {
  const user = useUser()
  const canStartTrial = user?.currentOrganization?.billing?.canStartTrial
  const upgradePathName = canStartTrial ? 'analyze-trial' : 'analyze-upgrade'

  const onOpenChange = (open: boolean): void => {
    if (open) return
    dismissModal()
  }

  return (
    <UpgradeDialog open={true} onOpenChange={onOpenChange}>
      <UpgradeDialog.Content size="xlarge">
        <UpgradeDialog.TextContent>
          <UpgradeDialog.Title>{ANALYZE_HEADING}</UpgradeDialog.Title>
          <UpgradeDialog.Description>
            {ANALYZE_DESCRIPTION}
          </UpgradeDialog.Description>
          <List>
            {ANALYZE_BULLET_POINTS.map((bullet) => (
              <List.Item key={bullet} icon={CheckIcon}>
                {bullet}
              </List.Item>
            ))}
          </List>
          <UpgradeDialog.Actions>
            <PaywallCtas
              feature="analyze"
              paywallType={MODALS.analyzeUpgradePath}
            />
          </UpgradeDialog.Actions>
        </UpgradeDialog.TextContent>
        <UpgradeDialog.Video>
          <ReactPlayer
            data-testid="wistia-video-player-analyze"
            className="react-player-wrapper"
            url="https://buffer.wistia.com/medias/yqnj7k1ckt"
            width="440px"
            height="245px"
            controls={true}
            onPlay={(): void => {
              trackCTAPaywallVideoPlayed({
                payload: {
                  progress: 0,
                  upgradePathName,
                },
                user,
              })
            }}
            onEnded={(): void => {
              trackCTAPaywallVideoPlayed({
                payload: {
                  progress: 1,
                  upgradePathName,
                },
                user,
              })
            }}
          />
        </UpgradeDialog.Video>
      </UpgradeDialog.Content>
    </UpgradeDialog>
  )
}

export default React.memo(AnalyzeUpgradePathModalContent)
